@if (memberProfile) {
    <div
        class="font-inter text-color w-full h-full"
        [ngClass]="{
            'bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]':
                dynamicPanel,
        }">
        <div class="w-full h-full p-4 flex flex-col">
            <div class="flex flex-col justify-start items-center">
                <div class="flex flex-row justify-center items-center w-full mb-4">
                    <fm-avatar
                        [isSaved]="memberProfile.saved"
                        size="lg"
                        class="mr-2"
                        [avatarLocation]="memberProfile.photoUrl" />
                    <div class="font-semibold text-color">{{ memberProfile.displayName }}</div>
                </div>

                <div
                    class="w-full flex items-center"
                    [ngClass]="{
                        'justify-between gap-1': dynamicPanel,
                        'justify-center gap-2': !dynamicPanel,
                    }">
                    @if (dynamicPanel) {
                        <p-select
                            size="small"
                            class="flex-1 h-8"
                            styleClass="w-full"
                            [options]="durationOptions"
                            optionLabel="labelDropdown"
                            [ngModel]="selectedDurationOption.value"
                            optionValue="value"
                            (onChange)="onDurationDropDownChanged($event)" />
                    } @else {
                        <p-select-button
                            class="w-[235px] h-10"
                            styleClass="w-full"
                            [options]="durationOptions"
                            optionLabel="labelButton"
                            [ngModel]="selectedDurationOption.value"
                            optionValue="value"
                            [allowEmpty]="false"
                            (onChange)="onDurationDropDownChanged($event)">
                            <ng-template #item let-item>
                                <div class="font-medium text-12 leading-[normal]">{{
                                    item.labelButton
                                }}</div>
                            </ng-template>
                        </p-select-button>
                    }
                    <div
                        class="h-8 flex justify-between items-center rounded-lg border border-[#e8dccd] bg-white px-2"
                        [ngClass]="{ 'h-8': dynamicPanel, 'h-10': !dynamicPanel }">
                        <label
                            class="text-left text-color leadning-[normal] mr-1"
                            [ngClass]="{
                                'text-[12.25px] font-light': dynamicPanel,
                                'text-12 leadning-[normal] font-medium': !dynamicPanel,
                            }"
                            for="quitemode"
                            >Quiet</label
                        >
                        <p-toggleSwitch
                            #quitemode
                            (onChange)="onQuietModeToggleSwtichChange($event)"
                            class="flex"
                            [(ngModel)]="selectedQuietMode" />
                    </div>
                </div>
            </div>

            @if (filteredSessionList.length > 0) {
                <div class="h-[calc(100%_-_100px)] mt-4">
                    <p-scrollpanel [style]="{ width: '100%', height: '100%' }">
                        <div
                            class="w-full flex flex-col justify-start"
                            [ngClass]="{
                                'items-start': dynamicPanel,
                                'items-center': !dynamicPanel,
                            }">
                            <div
                                class="flex flex-col items-center justify-start !mb-5 relative"
                                [ngClass]="{
                                    'w-full': dynamicPanel,
                                    'w-[320px]': !dynamicPanel,
                                }"
                                *ngFor="let day of filteredSessionList; let i = index">
                                <div
                                    class="text-13 text-color font-inter font-semibold sticky text-left top-0 z-[300] w-full bg-white !pb-4 pt-4"
                                    >{{ day.dateLabel }}</div
                                >

                                <div
                                    class="w-full flex flex-row justify-start items-center relative !mb-4 last:!mb-0"
                                    *ngFor="let session of day.sessions">
                                    <p-divider align="center" type="solid" layout="vertical">
                                        <span class="text-11 text-color font-medium">{{
                                            session.sessionDurationLabel
                                        }}</span>
                                    </p-divider>

                                    <fm-user-availability-list-item
                                        [ngClass]="{
                                            'w-[140px] lg:w-[160px] xl:w-[180px]': dynamicPanel,
                                            'w-[272px]': !dynamicPanel,
                                        }"
                                        [externalId]="session.externalId"
                                        [sessionTime]="session.sessionTime"
                                        [sessionDuration]="session.sessionDuration"
                                        [sessionState]="session.sessionState"
                                        [durationLabel]="session.sessionDurationLabel"
                                        [sessionTimeLabel]="session.timeLabel"
                                        [sessionActivityType]="session.activityType"
                                        [booked]="session.confirmed"
                                        [selected]="session.sessionTime == selectedSession"
                                        [disable]="disableBookSessions"
                                        [userId]="session.partnerUserId"
                                        [displayName]="session.partnerDisplayName"
                                        [profileSlug]="session.partnerProfileSlug"
                                        [profilePhoto]="session.profilePhoto"
                                        [saved]="session.saved"
                                        [bookingComplete]="session.actionComplete"
                                        [partnerQuietMode]="
                                            session.partnerPreferences.quietMode.value
                                        "
                                        [dynamicPanel]="dynamicPanel"
                                        (onCancelSession)="cancelSession($event)"
                                        (onBookSession)="bookSession($event)"
                                        (onSelectSession)="selectSession($event)" />
                                </div>
                            </div>
                        </div>
                    </p-scrollpanel>
                </div>
            } @else {
                <div class="w-full h-[calc(100%_-_153px)] mt-4">
                    <div
                        class="h-full xxxh-[calc(100vh_-_309px)] w-full flex flex-col items-center justify-start relative">
                        <div
                            *ngIf="listContentState == 'emptyList'"
                            class="error-text mt-20 mb-[10px]">
                            <div
                                class="font-inter font-medium text-center text-[#62647e] text-base"
                                style="margin-top: 125px"
                                >No sessions available at the moment!</div
                            >
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}
